<div class="new-dwelling-statistics">
    <div class="statistics-header">
        <div class="header-content">
            <h1>Statistikk</h1>
            <div class="sub-title">Nybygg</div>
            <div class="statistics-close" (click)="onCloseStatistics()"></div>
        </div>
    </div>
    <div class="statistics-wrapper">
        @if (currentPane === StatisticPanes.none) {
        <div class="navigation-wrapper">
            <div class="button" (click)="showStatisticsPane(StatisticPanes.sales)">Prisstatistikk</div>

            @if (hasDemographicsRole()) {
            <div class="button" (click)="showStatisticsPane(StatisticPanes.demographyInhabitants)">Demografi: Innbyggere
            </div>
            }
        </div>
        }
        @if (currentPane !== StatisticPanes.none) {
        <div class="content-wrapper">
            @if (currentPane === StatisticPanes.sales) {
            <div class="container">
                <div class="header-wrapper" (click)="showStatisticsPane(StatisticPanes.none)">
                    <div class="header">Prisstatistikk</div>
                    <div class="close"></div>
                </div>
                <div class="content">
                    STATISTIK
                </div>
            </div>
            }
            @if (currentPane === StatisticPanes.demographyInhabitants) {
            <div class="container">
                <div class="header-wrapper" (click)="showStatisticsPane(StatisticPanes.none)">
                    <div class="header">Demografi: Innbyggere</div>
                    <div class="close"></div>
                </div>
                <div class="content">
                    <inhabitant-demography></inhabitant-demography>
                </div>
            </div>
            }
        </div>
        }
    </div>
</div>